<app-header></app-header>
<!--<div [@routerTransition]="getRouteAnimation(route)">-->
  <router-outlet #route="outlet"></router-outlet>
<!--</div>-->


<!--<app-footer></app-footer>-->


